import {Component, OnInit} from '@angular/core';
import {StorageService} from '../../services/storage.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {PermissoesService} from '../../services/permissoes.service';
import {ActivatedRoute, Router} from '@angular/router';
import {cpf} from '../../util/format';
import * as moment from 'moment';

@Component({
  selector: 'app-cpf-liberado-csv',
  templateUrl: './cpf-liberado-csv.component.html',
  styleUrls: ['./cpf-liberado-csv.component.scss']
})
export class CpfLiberadoCsvComponent implements OnInit {

  searchQuery: any;
  config: any;
  solicitacao: any;
  nuSolicitacao: any;
  showModalAdd = false;
  currentPage = 1;
  totalPages = 1;
  range = 5;
  indexRange = 5;
  indexLimit = 0;
  listPermissoes: any[];
  paginacaoList = ['5', '10', '20', '30', '40', '50'];

  constructor(
    private storage: StorageService,
    private permissoesService: PermissoesService,
    private loading: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.config = JSON.parse(this.storage.getCurrentApp());
  }

  async ngOnInit() {
    window.scrollTo({top: 0, behavior: 'smooth'});
    this.route.queryParams.subscribe((queryParams: any) => {
      this.route.params.subscribe((params: any) => {
        this.solicitacao = params.solicitacao;
        this.nuSolicitacao = params.nuSolicitacao;
      });
    });
    await this.loadData();
  }

  async loadData() {
    this.loading.show();
    this.listPermissoes = await this.permissoesService.getPermissao(this.nuSolicitacao).toPromise();
    const array = this.solicitacao.split('-');
    if (array.length > 1) {
      this.solicitacao = array[0] + '/' + array[1];
    }
    this.loading.hide();
  }


  async onRangeChange(newRange: number) {
    this.range = newRange;
    if ((this.range * this.currentPage) <= this.indexLimit) {
      this.indexRange = this.range * this.currentPage;
    } else {
      this.indexRange = this.indexLimit;
    }
    await this.loadData();
  }

  async avancaPagina() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      if ((this.range * this.currentPage) <= this.indexLimit) {
        this.indexRange = this.range * this.currentPage;
      } else {
        this.indexRange = this.indexLimit;
      }
      await this.loadData();
    }
  }

  async voltaPagina() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.indexRange = this.range * this.currentPage;
      await this.loadData();
    }
  }

  async filter(searchQuery = false) {
    // this.loading.show();
    // const result: any = await this.solicitacoesService.getEstabFilhos(this.solicitacao.nuSolicitacao, this.solicitacao.nuAno, this.currentPage - 1, this.range, searchQuery);
    // this.estabFilhosFiltered = result.content;
    // this.solicitacao.estabelecimentosFilhos = this.estabFilhosFiltered;
    // this.indexLimit = result.totalElements;
    // this.totalPages = result.totalPages;
    // this.loading.hide();
  }

  async toogleStatus(item) {
    this.loading.show();
    try {
      const body = {
        ativo: !item.ativo,
        idPermissao: item.id,
      };
      await this.permissoesService.ativarPermissao(body);
      await this.loadData();
      this.loading.hide();
    } catch (e) {
      console.log(e);
      this.loading.hide();
    }
  }

  toogleModalAdd() {
    this.showModalAdd = !this.showModalAdd;
  }

  async fecharModalAdd(data) {
    if (data && data.cpf) {
      this.loading.show();
      try {
        const body = {
          cpf: data.cpf,
          idSolicitacao: this.nuSolicitacao,
        };
        await this.permissoesService.postPermissao(body);
        this.toogleModalAdd();
        await this.loadData();
        this.loading.hide();
      } catch (e) {
        console.log(e);
        this.loading.hide();
      }
    } else {
      this.toogleModalAdd();
    }
  }

  getData(data) {
    return moment(data).format('DD/MM/YYYY - HH:mm');
  }

  getCpf(data) {
    return cpf(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cpf-liberado-csv/cpf-liberado-csv.component.ts